/* eslint-disable import/prefer-default-export */
export const useErrorCode = {
  406: '内容未通过审核，请换个话题试一试～', // 内容包含敏感词
  500: '服务器繁忙，请稍后重试~',
  400: '网络请求异常，请重新尝试',
  404: '网络请求异常，请重新尝试',
}
